import React, { useEffect, useState } from "react";
import {
  DeleteAgeGraph,
  GetAgeGraphAll,
} from "../../../../../../../../core/Services";
import { BsFillTrashFill } from "react-icons/bs";
import { Dialog } from "primereact/dialog";
import { Button } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import { Paginator } from "primereact/paginator";

export default function AgeGraphTable({ uniqueCustomerId, months, DataTypes , tableKey , updateTableData}) {
  const [ageGraph, setAgeGraph] = useState([]);
  const [selectedAge, setSelectedAge] = useState(null);
  const [displayConfirmation, setDisplayConfirmation] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);
  const toast = useToast();

  useEffect(() => {
    GetAgeGraphAll(uniqueCustomerId)
      .then((data) => {
        setAgeGraph(data.data);
      })
      .catch((error) => {
        console.log("Ülke Veri Çekme Hatası", error);
      });
  }, [uniqueCustomerId, deleteSuccess, tableKey]);

  useEffect(() => {
    if (deleteSuccess) {
      toast({
        title: "Başarılı",
        description: "Veri başarıyla silindi.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
      updateTableData();
      setDeleteSuccess(false);
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteSuccess, toast]);

  const handleDelete = (viewVisitorId) => {
    setSelectedAge(viewVisitorId);
    setDisplayConfirmation(true);
  };

  const onDeleteConfirmation = () => {
    DeleteAgeGraph(selectedAge);
    setDeleteSuccess(true);
    setSelectedAge("");
    setDisplayConfirmation(false);
  };

  const onHide = () => {
    setDisplayConfirmation(false);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  return (
    <div className="ml-5">
      <div className="mb-3 font-bold text-xl">Düzenleme:</div>
      <table
        style={{
          fontFamily: "arial, sans-serif",
          borderCollapse: "collapse",
          width: "80%",
          maxHeight: "20%",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            ></th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Dönem
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Veri Adı
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Değer
            </th>
          </tr>
        </thead>
        <tbody>
          {ageGraph?.slice(first, first + rows).map((age, index) => (
            <tr
              key={age.id}
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              <td
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                {index + 1 + first}
              </td>
              <td
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                {months.find((month) => month.value === age.month)?.name}
              </td>
              <td
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                {
                  DataTypes.find(
                    (dataType) => dataType.value === age.age
                  )?.name
                }
              </td>
              <td
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                {age.value}
              </td>
              <td
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                <button
                  className="ml-2"
                  onClick={() => handleDelete(age.id)}
                >
                  <BsFillTrashFill />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Paginator
        first={first}
        rows={rows}
        totalRecords={ageGraph?.length}
        onPageChange={onPageChange}
      />
      <Dialog
        visible={displayConfirmation}
        style={{ width: "450px" }}
        onHide={onHide}
        position="center"
        header="İçerik Düzenleme"
      >
        <p>Veriyi silmek istediğinize emin misiniz?</p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <Button colorScheme="red" onClick={onHide}>
            Hayır
          </Button>
          <Button colorScheme="green" onClick={onDeleteConfirmation}>
            Evet
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
